var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unflatten = exports.subtractMatrices = exports.scaleMatrix = exports.multiplyMatrices = exports.isAffineMatrixFlat = exports.isAffineMatrix = exports.getRotationMatrix = exports.flatten = exports.decomposeMatrixIntoMatricesAndAngles = exports.decomposeMatrix = exports.addMatrices = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _worklet_1707959502623_init_data = {
    code: "function isAffineMatrixFlat(x){return Array.isArray(x)&&x.length===16&&x.every(function(element){return typeof element==='number'&&!isNaN(element);});}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["isAffineMatrixFlat","x","Array","isArray","length","every","element","isNaN"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AA2BO,SAAAA,kBAASA,CAAmBC,CAAC,CAAU,CAE5C,MACE,CAAAC,KAAK,CAACC,OAAO,CAACF,CAAC,CAAC,EAChBA,CAAC,CAACG,MAAM,GAAK,EAAE,EACfH,CAAC,CAACI,KAAK,CAAE,SAAAC,OAAO,QAAK,OAAO,CAAAA,OAAO,GAAK,QAAQ,EAAI,CAACC,KAAK,CAACD,OAAO,CAAC,GAAC,CAExE"}',
    version: "3.5.4"
};
var isAffineMatrixFlat = exports.isAffineMatrixFlat = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var isAffineMatrixFlat = function isAffineMatrixFlat(x) {
        return Array.isArray(x) && x.length === 16 && x.every(function(element) {
            return typeof element === "number" && !isNaN(element);
        });
    };
    isAffineMatrixFlat.__closure = {};
    isAffineMatrixFlat.__initData = _worklet_1707959502623_init_data;
    isAffineMatrixFlat.__workletHash = 1707959502623;
    isAffineMatrixFlat.__stackDetails = _e;
    return isAffineMatrixFlat;
}();
var _worklet_10460689553819_init_data = {
    code: "function isAffineMatrix(x){return Array.isArray(x)&&x.length===4&&x.every(function(row){return Array.isArray(row)&&row.length===4&&row.every(function(element){return typeof element==='number'&&!isNaN(element);});});}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["isAffineMatrix","x","Array","isArray","length","every","row","element","isNaN"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AAqCO,SAAAA,cAASA,CAAeC,CAAC,CAAU,CAExC,MACE,CAAAC,KAAK,CAACC,OAAO,CAACF,CAAC,CAAC,EAChBA,CAAC,CAACG,MAAM,GAAK,CAAC,EACdH,CAAC,CAACI,KAAK,CACJ,SAAAC,GAAG,QACF,CAAAJ,KAAK,CAACC,OAAO,CAACG,GAAG,CAAC,EAClBA,GAAG,CAACF,MAAM,GAAK,CAAC,EAChBE,GAAG,CAACD,KAAK,CAAE,SAAAE,OAAO,QAAK,OAAO,CAAAA,OAAO,GAAK,QAAQ,EAAI,CAACC,KAAK,CAACD,OAAO,CAAC,GACzE,GAAC,CAEL"}',
    version: "3.5.4"
};
var isAffineMatrix = exports.isAffineMatrix = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var isAffineMatrix = function isAffineMatrix(x) {
        return Array.isArray(x) && x.length === 4 && x.every(function(row) {
            return Array.isArray(row) && row.length === 4 && row.every(function(element) {
                return typeof element === "number" && !isNaN(element);
            });
        });
    };
    isAffineMatrix.__closure = {};
    isAffineMatrix.__initData = _worklet_10460689553819_init_data;
    isAffineMatrix.__workletHash = 10460689553819;
    isAffineMatrix.__stackDetails = _e;
    return isAffineMatrix;
}();
var _worklet_2702927761571_init_data = {
    code: "function flatten(matrix){return matrix.flat();}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["flatten","matrix","flat"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AAmDO,SAAAA,OAASA,CAAQC,MAAA,CAAqB,CAE3C,MAAO,CAAAA,MAAM,CAACC,IAAI,CAAC,CAAC,CACtB"}',
    version: "3.5.4"
};
var flatten = exports.flatten = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var flatten = function flatten(matrix) {
        return matrix.flat();
    };
    flatten.__closure = {};
    flatten.__initData = _worklet_2702927761571_init_data;
    flatten.__workletHash = 2702927761571;
    flatten.__stackDetails = _e;
    return flatten;
}();
var _worklet_7629642405327_init_data = {
    code: "function unflatten(m){return[[m[0],m[1],m[2],m[3]],[m[4],m[5],m[6],m[7]],[m[8],m[9],m[10],m[11]],[m[12],m[13],m[14],m[15]]];}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["unflatten","m"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AAyDO,SAAAA,SAASA,CAAUC,CAAC,CAAmB,CAE5C,MAAO,CACL,CAACA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,CAAC,CAAC,CAAC,CACxB,CAACA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,CAAC,CAAC,CAAC,CACxB,CAACA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,EAAE,CAAC,CAAEA,CAAC,CAAC,EAAE,CAAC,CAAC,CAC1B,CAACA,CAAC,CAAC,EAAE,CAAC,CAAEA,CAAC,CAAC,EAAE,CAAC,CAAEA,CAAC,CAAC,EAAE,CAAC,CAAEA,CAAC,CAAC,EAAE,CAAC,CAAC,CAC7B,CACH"}',
    version: "3.5.4"
};
var unflatten = exports.unflatten = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var unflatten = function unflatten(m) {
        return [
            [
                m[0],
                m[1],
                m[2],
                m[3]
            ],
            [
                m[4],
                m[5],
                m[6],
                m[7]
            ],
            [
                m[8],
                m[9],
                m[10],
                m[11]
            ],
            [
                m[12],
                m[13],
                m[14],
                m[15]
            ]
        ];
    };
    unflatten.__closure = {};
    unflatten.__initData = _worklet_7629642405327_init_data;
    unflatten.__workletHash = 7629642405327;
    unflatten.__stackDetails = _e;
    return unflatten;
}();
var _worklet_832061382511_init_data = {
    code: "function maybeFlattenMatrix(matrix){const{isAffineMatrix,flatten}=this.__closure;return isAffineMatrix(matrix)?flatten(matrix):matrix;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["maybeFlattenMatrix","matrix","isAffineMatrix","flatten","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AAmEA,SAAAA,kBAASA,CACPC,MAAA,CACD,OAAAC,cAAA,CAAAC,OAAA,OAAAC,SAAA,CAEC,MAAO,CAAAF,cAAc,CAACD,MAAM,CAAC,CAAGE,OAAO,CAACF,MAAM,CAAC,CAAGA,MAAM,CAC1D"}',
    version: "3.5.4"
};
var maybeFlattenMatrix = function() {
    var _e = [
        new global.Error(),
        -3,
        -27
    ];
    var maybeFlattenMatrix = function maybeFlattenMatrix(matrix) {
        return isAffineMatrix(matrix) ? flatten(matrix) : matrix;
    };
    maybeFlattenMatrix.__closure = {
        isAffineMatrix: isAffineMatrix,
        flatten: flatten
    };
    maybeFlattenMatrix.__initData = _worklet_832061382511_init_data;
    maybeFlattenMatrix.__workletHash = 832061382511;
    maybeFlattenMatrix.__stackDetails = _e;
    return maybeFlattenMatrix;
}();
var _worklet_9003387220364_init_data = {
    code: "function multiplyMatrices(a,b){return[[a[0][0]*b[0][0]+a[0][1]*b[1][0]+a[0][2]*b[2][0]+a[0][3]*b[3][0],a[0][0]*b[0][1]+a[0][1]*b[1][1]+a[0][2]*b[2][1]+a[0][3]*b[3][1],a[0][0]*b[0][2]+a[0][1]*b[1][2]+a[0][2]*b[2][2]+a[0][3]*b[3][2],a[0][0]*b[0][3]+a[0][1]*b[1][3]+a[0][2]*b[2][3]+a[0][3]*b[3][3]],[a[1][0]*b[0][0]+a[1][1]*b[1][0]+a[1][2]*b[2][0]+a[1][3]*b[3][0],a[1][0]*b[0][1]+a[1][1]*b[1][1]+a[1][2]*b[2][1]+a[1][3]*b[3][1],a[1][0]*b[0][2]+a[1][1]*b[1][2]+a[1][2]*b[2][2]+a[1][3]*b[3][2],a[1][0]*b[0][3]+a[1][1]*b[1][3]+a[1][2]*b[2][3]+a[1][3]*b[3][3]],[a[2][0]*b[0][0]+a[2][1]*b[1][0]+a[2][2]*b[2][0]+a[2][3]*b[3][0],a[2][0]*b[0][1]+a[2][1]*b[1][1]+a[2][2]*b[2][1]+a[2][3]*b[3][1],a[2][0]*b[0][2]+a[2][1]*b[1][2]+a[2][2]*b[2][2]+a[2][3]*b[3][2],a[2][0]*b[0][3]+a[2][1]*b[1][3]+a[2][2]*b[2][3]+a[2][3]*b[3][3]],[a[3][0]*b[0][0]+a[3][1]*b[1][0]+a[3][2]*b[2][0]+a[3][3]*b[3][0],a[3][0]*b[0][1]+a[3][1]*b[1][1]+a[3][2]*b[2][1]+a[3][3]*b[3][1],a[3][0]*b[0][2]+a[3][1]*b[1][2]+a[3][2]*b[2][2]+a[3][3]*b[3][2],a[3][0]*b[0][3]+a[3][1]*b[1][3]+a[3][2]*b[2][3]+a[3][3]*b[3][3]]];}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["multiplyMatrices","a","b"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AA0EO,SAAAA,gBAASA,CACdC,CAAC,CAAcC,CACd,CACF,CAEC,MAAO,CACL,CACED,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAEnBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAEnBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAEnBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACpB,CACD,CACED,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAEnBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAEnBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAEnBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACpB,CACD,CACED,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAEnBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAEnBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAEnBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACpB,CACD,CACED,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAEnBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAEnBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAEnBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACfD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACjBD,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAGC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CACpB,CACF,CACH"}',
    version: "3.5.4"
};
var multiplyMatrices = exports.multiplyMatrices = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var multiplyMatrices = function multiplyMatrices(a, b) {
        return [
            [
                a[0][0] * b[0][0] + a[0][1] * b[1][0] + a[0][2] * b[2][0] + a[0][3] * b[3][0],
                a[0][0] * b[0][1] + a[0][1] * b[1][1] + a[0][2] * b[2][1] + a[0][3] * b[3][1],
                a[0][0] * b[0][2] + a[0][1] * b[1][2] + a[0][2] * b[2][2] + a[0][3] * b[3][2],
                a[0][0] * b[0][3] + a[0][1] * b[1][3] + a[0][2] * b[2][3] + a[0][3] * b[3][3]
            ],
            [
                a[1][0] * b[0][0] + a[1][1] * b[1][0] + a[1][2] * b[2][0] + a[1][3] * b[3][0],
                a[1][0] * b[0][1] + a[1][1] * b[1][1] + a[1][2] * b[2][1] + a[1][3] * b[3][1],
                a[1][0] * b[0][2] + a[1][1] * b[1][2] + a[1][2] * b[2][2] + a[1][3] * b[3][2],
                a[1][0] * b[0][3] + a[1][1] * b[1][3] + a[1][2] * b[2][3] + a[1][3] * b[3][3]
            ],
            [
                a[2][0] * b[0][0] + a[2][1] * b[1][0] + a[2][2] * b[2][0] + a[2][3] * b[3][0],
                a[2][0] * b[0][1] + a[2][1] * b[1][1] + a[2][2] * b[2][1] + a[2][3] * b[3][1],
                a[2][0] * b[0][2] + a[2][1] * b[1][2] + a[2][2] * b[2][2] + a[2][3] * b[3][2],
                a[2][0] * b[0][3] + a[2][1] * b[1][3] + a[2][2] * b[2][3] + a[2][3] * b[3][3]
            ],
            [
                a[3][0] * b[0][0] + a[3][1] * b[1][0] + a[3][2] * b[2][0] + a[3][3] * b[3][0],
                a[3][0] * b[0][1] + a[3][1] * b[1][1] + a[3][2] * b[2][1] + a[3][3] * b[3][1],
                a[3][0] * b[0][2] + a[3][1] * b[1][2] + a[3][2] * b[2][2] + a[3][3] * b[3][2],
                a[3][0] * b[0][3] + a[3][1] * b[1][3] + a[3][2] * b[2][3] + a[3][3] * b[3][3]
            ]
        ];
    };
    multiplyMatrices.__closure = {};
    multiplyMatrices.__initData = _worklet_9003387220364_init_data;
    multiplyMatrices.__workletHash = 9003387220364;
    multiplyMatrices.__stackDetails = _e;
    return multiplyMatrices;
}();
var _worklet_13621555220883_init_data = {
    code: "function subtractMatrices(maybeFlatA,maybeFlatB){const{isAffineMatrixFlat,maybeFlattenMatrix,unflatten}=this.__closure;const isFlatOnStart=isAffineMatrixFlat(maybeFlatA);const a=maybeFlattenMatrix(maybeFlatA);const b=maybeFlattenMatrix(maybeFlatB);const c=a.map(function(_,i){return a[i]-b[i];});return isFlatOnStart?c:unflatten(c);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["subtractMatrices","maybeFlatA","maybeFlatB","isAffineMatrixFlat","maybeFlattenMatrix","unflatten","__closure","isFlatOnStart","a","b","c","map","_","i"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AAuKO,SAAAA,gBAASA,CAAiBC,UAC/B,CAAaC,UACb,CACD,OAAAC,kBAAA,CAAAC,kBAAA,CAAAC,SAAA,OAAAC,SAAA,CAEC,KAAM,CAAAC,aAAa,CAAGJ,kBAAkB,CAACF,UAAU,CAAC,CACpD,KAAM,CAAAO,CAAmB,CAAGJ,kBAAkB,CAACH,UAAU,CAAC,CAC1D,KAAM,CAAAQ,CAAmB,CAAGL,kBAAkB,CAACF,UAAU,CAAC,CAE1D,KAAM,CAAAQ,CAAC,CAAGF,CAAC,CAACG,GAAG,CAAC,SAACC,CAAC,CAAEC,CAAC,QAAK,CAAAL,CAAC,CAACK,CAAC,CAAC,CAAGJ,CAAC,CAACI,CAAC,CAAC,GAAqB,CAC1D,MAAO,CAAAN,aAAa,CAAIG,CAAC,CAAUL,SAAS,CAACK,CAAC,CAAO,CACvD"}',
    version: "3.5.4"
};
var subtractMatrices = exports.subtractMatrices = function() {
    var _e = [
        new global.Error(),
        -4,
        -27
    ];
    var subtractMatrices = function subtractMatrices(maybeFlatA, maybeFlatB) {
        var isFlatOnStart = isAffineMatrixFlat(maybeFlatA);
        var a = maybeFlattenMatrix(maybeFlatA);
        var b = maybeFlattenMatrix(maybeFlatB);
        var c = a.map(function(_, i) {
            return a[i] - b[i];
        });
        return isFlatOnStart ? c : unflatten(c);
    };
    subtractMatrices.__closure = {
        isAffineMatrixFlat: isAffineMatrixFlat,
        maybeFlattenMatrix: maybeFlattenMatrix,
        unflatten: unflatten
    };
    subtractMatrices.__initData = _worklet_13621555220883_init_data;
    subtractMatrices.__workletHash = 13621555220883;
    subtractMatrices.__stackDetails = _e;
    return subtractMatrices;
}();
var _worklet_12613533663840_init_data = {
    code: "function addMatrices(maybeFlatA,maybeFlatB){const{isAffineMatrixFlat,maybeFlattenMatrix,unflatten}=this.__closure;const isFlatOnStart=isAffineMatrixFlat(maybeFlatA);const a=maybeFlattenMatrix(maybeFlatA);const b=maybeFlattenMatrix(maybeFlatB);const c=a.map(function(_,i){return a[i]+b[i];});return isFlatOnStart?c:unflatten(c);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["addMatrices","maybeFlatA","maybeFlatB","isAffineMatrixFlat","maybeFlattenMatrix","unflatten","__closure","isFlatOnStart","a","b","c","map","_","i"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AAoLO,SAAAA,WAASA,CAAYC,UAC1B,CAAaC,UACb,CACD,OAAAC,kBAAA,CAAAC,kBAAA,CAAAC,SAAA,OAAAC,SAAA,CAEC,KAAM,CAAAC,aAAa,CAAGJ,kBAAkB,CAACF,UAAU,CAAC,CACpD,KAAM,CAAAO,CAAC,CAAGJ,kBAAkB,CAACH,UAAU,CAAC,CACxC,KAAM,CAAAQ,CAAC,CAAGL,kBAAkB,CAACF,UAAU,CAAC,CAExC,KAAM,CAAAQ,CAAC,CAAGF,CAAC,CAACG,GAAG,CAAC,SAACC,CAAC,CAAEC,CAAC,QAAK,CAAAL,CAAC,CAACK,CAAC,CAAC,CAAGJ,CAAC,CAACI,CAAC,CAAC,GAAqB,CAC1D,MAAO,CAAAN,aAAa,CAAIG,CAAC,CAAUL,SAAS,CAACK,CAAC,CAAO,CACvD"}',
    version: "3.5.4"
};
var addMatrices = exports.addMatrices = function() {
    var _e = [
        new global.Error(),
        -4,
        -27
    ];
    var addMatrices = function addMatrices(maybeFlatA, maybeFlatB) {
        var isFlatOnStart = isAffineMatrixFlat(maybeFlatA);
        var a = maybeFlattenMatrix(maybeFlatA);
        var b = maybeFlattenMatrix(maybeFlatB);
        var c = a.map(function(_, i) {
            return a[i] + b[i];
        });
        return isFlatOnStart ? c : unflatten(c);
    };
    addMatrices.__closure = {
        isAffineMatrixFlat: isAffineMatrixFlat,
        maybeFlattenMatrix: maybeFlattenMatrix,
        unflatten: unflatten
    };
    addMatrices.__initData = _worklet_12613533663840_init_data;
    addMatrices.__workletHash = 12613533663840;
    addMatrices.__stackDetails = _e;
    return addMatrices;
}();
var _worklet_719755965988_init_data = {
    code: "function scaleMatrix(maybeFlatA,scalar){const{isAffineMatrixFlat,maybeFlattenMatrix,unflatten}=this.__closure;const isFlatOnStart=isAffineMatrixFlat(maybeFlatA);const a=maybeFlattenMatrix(maybeFlatA);const b=a.map(function(x){return x*scalar;});return isFlatOnStart?b:unflatten(b);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["scaleMatrix","maybeFlatA","scalar","isAffineMatrixFlat","maybeFlattenMatrix","unflatten","__closure","isFlatOnStart","a","b","map","x"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AAiMO,SAAAA,WAASA,CAAYC,UAC1B,CAAaC,MACb,CACD,OAAAC,kBAAA,CAAAC,kBAAA,CAAAC,SAAA,OAAAC,SAAA,CAEC,KAAM,CAAAC,aAAa,CAAGJ,kBAAkB,CAACF,UAAU,CAAC,CACpD,KAAM,CAAAO,CAAC,CAAGJ,kBAAkB,CAACH,UAAU,CAAC,CAExC,KAAM,CAAAQ,CAAC,CAAGD,CAAC,CAACE,GAAG,CAAE,SAAAC,CAAC,QAAK,CAAAA,CAAC,CAAGT,MAAM,GAAqB,CACtD,MAAO,CAAAK,aAAa,CAAIE,CAAC,CAAUJ,SAAS,CAACI,CAAC,CAAO,CACvD"}',
    version: "3.5.4"
};
var scaleMatrix = exports.scaleMatrix = function() {
    var _e = [
        new global.Error(),
        -4,
        -27
    ];
    var scaleMatrix = function scaleMatrix(maybeFlatA, scalar) {
        var isFlatOnStart = isAffineMatrixFlat(maybeFlatA);
        var a = maybeFlattenMatrix(maybeFlatA);
        var b = a.map(function(x) {
            return x * scalar;
        });
        return isFlatOnStart ? b : unflatten(b);
    };
    scaleMatrix.__closure = {
        isAffineMatrixFlat: isAffineMatrixFlat,
        maybeFlattenMatrix: maybeFlattenMatrix,
        unflatten: unflatten
    };
    scaleMatrix.__initData = _worklet_719755965988_init_data;
    scaleMatrix.__workletHash = 719755965988;
    scaleMatrix.__stackDetails = _e;
    return scaleMatrix;
}();
var _worklet_5109197941223_init_data = {
    code: "function getRotationMatrix(angle,axis='z'){const cos=Math.cos(angle);const sin=Math.sin(angle);switch(axis){case'z':return[[cos,sin,0,0],[-sin,cos,0,0],[0,0,1,0],[0,0,0,1]];case'y':return[[cos,0,-sin,0],[0,1,0,0],[sin,0,cos,0],[0,0,0,1]];case'x':return[[1,0,0,0],[0,cos,sin,0],[0,-sin,cos,0],[0,0,0,1]];}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["getRotationMatrix","angle","axis","cos","Math","sin"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AA6MO,SAAAA,iBAASA,CACdC,KAAA,CAAaC,IACb,CAAU,GAAG,CACd,CAEC,KAAM,CAAAC,GAAG,CAAGC,IAAI,CAACD,GAAG,CAACF,KAAK,CAAC,CAC3B,KAAM,CAAAI,GAAG,CAAGD,IAAI,CAACC,GAAG,CAACJ,KAAK,CAAC,CAC3B,OAAQC,IAAI,EACV,IAAK,GAAG,CACN,MAAO,CACL,CAACC,GAAG,CAAEE,GAAG,CAAE,CAAC,CAAE,CAAC,CAAC,CAChB,CAAC,CAACA,GAAG,CAAEF,GAAG,CAAE,CAAC,CAAE,CAAC,CAAC,CACjB,CAAC,CAAC,CAAE,CAAC,CAAE,CAAC,CAAE,CAAC,CAAC,CACZ,CAAC,CAAC,CAAE,CAAC,CAAE,CAAC,CAAE,CAAC,CAAC,CACb,CACH,IAAK,GAAG,CACN,MAAO,CACL,CAACA,GAAG,CAAE,CAAC,CAAE,CAACE,GAAG,CAAE,CAAC,CAAC,CACjB,CAAC,CAAC,CAAE,CAAC,CAAE,CAAC,CAAE,CAAC,CAAC,CACZ,CAACA,GAAG,CAAE,CAAC,CAAEF,GAAG,CAAE,CAAC,CAAC,CAChB,CAAC,CAAC,CAAE,CAAC,CAAE,CAAC,CAAE,CAAC,CAAC,CACb,CACH,IAAK,GAAG,CACN,MAAO,CACL,CAAC,CAAC,CAAE,CAAC,CAAE,CAAC,CAAE,CAAC,CAAC,CACZ,CAAC,CAAC,CAAEA,GAAG,CAAEE,GAAG,CAAE,CAAC,CAAC,CAChB,CAAC,CAAC,CAAE,CAACA,GAAG,CAAEF,GAAG,CAAE,CAAC,CAAC,CACjB,CAAC,CAAC,CAAE,CAAC,CAAE,CAAC,CAAE,CAAC,CAAC,CACb,CACL,CACF"}',
    version: "3.5.4"
};
var getRotationMatrix = exports.getRotationMatrix = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var getRotationMatrix = function getRotationMatrix(angle) {
        var axis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "z";
        var cos = Math.cos(angle);
        var sin = Math.sin(angle);
        switch(axis){
            case "z":
                return [
                    [
                        cos,
                        sin,
                        0,
                        0
                    ],
                    [
                        -sin,
                        cos,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        1,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ]
                ];
            case "y":
                return [
                    [
                        cos,
                        0,
                        -sin,
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        0
                    ],
                    [
                        sin,
                        0,
                        cos,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ]
                ];
            case "x":
                return [
                    [
                        1,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        cos,
                        sin,
                        0
                    ],
                    [
                        0,
                        -sin,
                        cos,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ]
                ];
        }
    };
    getRotationMatrix.__closure = {};
    getRotationMatrix.__initData = _worklet_5109197941223_init_data;
    getRotationMatrix.__workletHash = 5109197941223;
    getRotationMatrix.__stackDetails = _e;
    return getRotationMatrix;
}();
var _worklet_1147516857584_init_data = {
    code: "function norm3d(x,y,z){return Math.sqrt(x*x+y*y+z*z);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["norm3d","x","y","z","Math","sqrt"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AA6OA,SAAAA,MAASA,CAAOC,CAAC,CAAQC,CAAG,CAAQC,CAAG,CAAQ,CAE7C,MAAO,CAAAC,IAAI,CAACC,IAAI,CAACJ,CAAC,CAAGA,CAAC,CAAGC,CAAC,CAAGA,CAAC,CAAGC,CAAC,CAAGA,CAAC,CAAC,CACzC"}',
    version: "3.5.4"
};
var norm3d = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var norm3d = function norm3d(x, y, z) {
        return Math.sqrt(x * x + y * y + z * z);
    };
    norm3d.__closure = {};
    norm3d.__initData = _worklet_1147516857584_init_data;
    norm3d.__workletHash = 1147516857584;
    norm3d.__stackDetails = _e;
    return norm3d;
}();
var _worklet_10025689255618_init_data = {
    code: "function transposeMatrix(matrix){const{flatten}=this.__closure;const m=flatten(matrix);return[[m[0],m[4],m[8],m[12]],[m[1],m[5],m[9],m[13]],[m[2],m[6],m[10],m[14]],[m[3],m[7],m[11],m[15]]];}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["transposeMatrix","matrix","flatten","__closure","m"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AAkPA,SAAAA,eAASA,CAAgBC,MAAA,CAAqB,OAAAC,OAAA,OAAAC,SAAA,CAE5C,KAAM,CAAAC,CAAC,CAAGF,OAAO,CAACD,MAAM,CAAC,CACzB,MAAO,CACL,CAACG,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,EAAE,CAAC,CAAC,CACzB,CAACA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,EAAE,CAAC,CAAC,CACzB,CAACA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,EAAE,CAAC,CAAEA,CAAC,CAAC,EAAE,CAAC,CAAC,CAC1B,CAACA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,CAAC,CAAC,CAAEA,CAAC,CAAC,EAAE,CAAC,CAAEA,CAAC,CAAC,EAAE,CAAC,CAAC,CAC3B,CACH"}',
    version: "3.5.4"
};
var transposeMatrix = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var transposeMatrix = function transposeMatrix(matrix) {
        var m = flatten(matrix);
        return [
            [
                m[0],
                m[4],
                m[8],
                m[12]
            ],
            [
                m[1],
                m[5],
                m[9],
                m[13]
            ],
            [
                m[2],
                m[6],
                m[10],
                m[14]
            ],
            [
                m[3],
                m[7],
                m[11],
                m[15]
            ]
        ];
    };
    transposeMatrix.__closure = {
        flatten: flatten
    };
    transposeMatrix.__initData = _worklet_10025689255618_init_data;
    transposeMatrix.__workletHash = 10025689255618;
    transposeMatrix.__stackDetails = _e;
    return transposeMatrix;
}();
var _worklet_12756525216035_init_data = {
    code: 'function assertVectorsHaveEqualLengths(a,b){const{__DEV__}=this.__closure;if(__DEV__&&a.length!==b.length){throw new Error("[Reanimated] Cannot calculate inner product of two vectors of different lengths. Length of "+a+" is "+a.length+" and length of "+b+" is "+b.length+".");}}',
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["assertVectorsHaveEqualLengths","a","b","__DEV__","__closure","length","Error"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AA6PA,SAAAA,6BAASA,CAA8BC,CAAC,CAAUC,CAAG,CAAU,OAAAC,OAAA,OAAAC,SAAA,CAE7D,GAAID,OAAO,EAAIF,CAAC,CAACI,MAAM,GAAKH,CAAC,CAACG,MAAM,CAAE,CACpC,KAAM,IAAI,CAAAC,KAAK,+FACiFL,CAAE,QAAMA,CAAC,CAACI,MAAO,mBAAiBH,CAAE,QAAMA,CAAC,CAACG,MAAO,IACnJ,CAAC,CACH,CACF"}',
    version: "3.5.4"
};
var assertVectorsHaveEqualLengths = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var assertVectorsHaveEqualLengths = function assertVectorsHaveEqualLengths(a, b) {
        if (__DEV__ && a.length !== b.length) {
            throw new Error("[Reanimated] Cannot calculate inner product of two vectors of different lengths. Length of ".concat(a, " is ").concat(a.length, " and length of ").concat(b, " is ").concat(b.length, "."));
        }
    };
    assertVectorsHaveEqualLengths.__closure = {
        __DEV__: __DEV__
    };
    assertVectorsHaveEqualLengths.__initData = _worklet_12756525216035_init_data;
    assertVectorsHaveEqualLengths.__workletHash = 12756525216035;
    assertVectorsHaveEqualLengths.__stackDetails = _e;
    return assertVectorsHaveEqualLengths;
}();
var _worklet_7216976607474_init_data = {
    code: "function innerProduct(a,b){const{assertVectorsHaveEqualLengths}=this.__closure;assertVectorsHaveEqualLengths(a,b);return a.reduce(function(acc,_,i){return acc+a[i]*b[i];},0);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["innerProduct","a","b","assertVectorsHaveEqualLengths","__closure","reduce","acc","_","i"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AAsQA,SAAAA,YAASA,CAAaC,CAAC,CAAUC,CAAG,CAAU,OAAAC,6BAAA,OAAAC,SAAA,CAE5CD,6BAA6B,CAACF,CAAC,CAAEC,CAAC,CAAC,CACnC,MAAO,CAAAD,CAAC,CAACI,MAAM,CAAC,SAACC,GAAG,CAAEC,CAAC,CAAEC,CAAC,QAAK,CAAAF,GAAG,CAAGL,CAAC,CAACO,CAAC,CAAC,CAAGN,CAAC,CAACM,CAAC,CAAC,GAAE,CAAC,CAAC,CACtD"}',
    version: "3.5.4"
};
var innerProduct = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var innerProduct = function innerProduct(a, b) {
        assertVectorsHaveEqualLengths(a, b);
        return a.reduce(function(acc, _, i) {
            return acc + a[i] * b[i];
        }, 0);
    };
    innerProduct.__closure = {
        assertVectorsHaveEqualLengths: assertVectorsHaveEqualLengths
    };
    innerProduct.__initData = _worklet_7216976607474_init_data;
    innerProduct.__workletHash = 7216976607474;
    innerProduct.__stackDetails = _e;
    return innerProduct;
}();
var _worklet_16215146979505_init_data = {
    code: "function projection(u,a){const{assertVectorsHaveEqualLengths,innerProduct}=this.__closure;assertVectorsHaveEqualLengths(u,a);const s=innerProduct(u,a)/innerProduct(u,u);return u.map(function(e){return e*s;});}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["projection","u","a","assertVectorsHaveEqualLengths","innerProduct","__closure","s","map","e"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AA4QA,SAAAA,UAASA,CAAWC,CAAC,CAAUC,CAAG,CAAU,OAAAC,6BAAA,CAAAC,YAAA,OAAAC,SAAA,CAE1CF,6BAA6B,CAACF,CAAC,CAAEC,CAAC,CAAC,CACnC,KAAM,CAAAI,CAAC,CAAGF,YAAY,CAACH,CAAC,CAAEC,CAAC,CAAC,CAAGE,YAAY,CAACH,CAAC,CAAEA,CAAC,CAAC,CACjD,MAAO,CAAAA,CAAC,CAACM,GAAG,CAAE,SAAAC,CAAC,QAAK,CAAAA,CAAC,CAAGF,CAAC,GAAC,CAC5B"}',
    version: "3.5.4"
};
var projection = function() {
    var _e = [
        new global.Error(),
        -3,
        -27
    ];
    var projection = function projection(u, a) {
        assertVectorsHaveEqualLengths(u, a);
        var s = innerProduct(u, a) / innerProduct(u, u);
        return u.map(function(e) {
            return e * s;
        });
    };
    projection.__closure = {
        assertVectorsHaveEqualLengths: assertVectorsHaveEqualLengths,
        innerProduct: innerProduct
    };
    projection.__initData = _worklet_16215146979505_init_data;
    projection.__workletHash = 16215146979505;
    projection.__stackDetails = _e;
    return projection;
}();
var _worklet_2650969212825_init_data = {
    code: "function subtractVectors(a,b){const{assertVectorsHaveEqualLengths}=this.__closure;assertVectorsHaveEqualLengths(a,b);return a.map(function(_,i){return a[i]-b[i];});}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["subtractVectors","a","b","assertVectorsHaveEqualLengths","__closure","map","_","i"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AAmRA,SAAAA,eAASA,CAAgBC,CAAC,CAAUC,CAAG,CAAU,OAAAC,6BAAA,OAAAC,SAAA,CAE/CD,6BAA6B,CAACF,CAAC,CAAEC,CAAC,CAAC,CACnC,MAAO,CAAAD,CAAC,CAACI,GAAG,CAAC,SAACC,CAAC,CAAEC,CAAC,QAAK,CAAAN,CAAC,CAACM,CAAC,CAAC,CAAGL,CAAC,CAACK,CAAC,CAAC,GAAC,CACrC"}',
    version: "3.5.4"
};
var subtractVectors = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var subtractVectors = function subtractVectors(a, b) {
        assertVectorsHaveEqualLengths(a, b);
        return a.map(function(_, i) {
            return a[i] - b[i];
        });
    };
    subtractVectors.__closure = {
        assertVectorsHaveEqualLengths: assertVectorsHaveEqualLengths
    };
    subtractVectors.__initData = _worklet_2650969212825_init_data;
    subtractVectors.__workletHash = 2650969212825;
    subtractVectors.__stackDetails = _e;
    return subtractVectors;
}();
var _worklet_16040459946099_init_data = {
    code: "function scaleVector(u,a){return u.map(function(e){return e*a;});}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["scaleVector","u","a","map","e"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AAyRA,SAAAA,WAASA,CAAYC,CAAC,CAAUC,CAAG,CAAQ,CAEzC,MAAO,CAAAD,CAAC,CAACE,GAAG,CAAE,SAAAC,CAAC,QAAK,CAAAA,CAAC,CAAGF,CAAC,GAAC,CAC5B"}',
    version: "3.5.4"
};
var scaleVector = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var scaleVector = function scaleVector(u, a) {
        return u.map(function(e) {
            return e * a;
        });
    };
    scaleVector.__closure = {};
    scaleVector.__initData = _worklet_16040459946099_init_data;
    scaleVector.__workletHash = 16040459946099;
    scaleVector.__stackDetails = _e;
    return scaleVector;
}();
var _worklet_9359996019682_init_data = {
    code: "function gramSchmidtAlgorithm(matrix){const{subtractVectors,projection,scaleVector,innerProduct,transposeMatrix}=this.__closure;const[a0,a1,a2,a3]=matrix;const u0=a0;const u1=subtractVectors(a1,projection(u0,a1));const u2=subtractVectors(subtractVectors(a2,projection(u0,a2)),projection(u1,a2));const u3=subtractVectors(subtractVectors(subtractVectors(a3,projection(u0,a3)),projection(u1,a3)),projection(u2,a3));const[e0,e1,e2,e3]=[u0,u1,u2,u3].map(function(u){return scaleVector(u,1/Math.sqrt(innerProduct(u,u)));});const rotationMatrix=[[e0[0],e1[0],e2[0],e3[0]],[e0[1],e1[1],e2[1],e3[1]],[e0[2],e1[2],e2[2],e3[2]],[e0[3],e1[3],e2[3],e3[3]]];const skewMatrix=[[innerProduct(e0,a0),innerProduct(e0,a1),innerProduct(e0,a2),innerProduct(e0,a3)],[0,innerProduct(e1,a1),innerProduct(e1,a2),innerProduct(e1,a3)],[0,0,innerProduct(e2,a2),innerProduct(e2,a3)],[0,0,0,innerProduct(e3,a3)]];return{rotationMatrix:transposeMatrix(rotationMatrix),skewMatrix:transposeMatrix(skewMatrix)};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["gramSchmidtAlgorithm","matrix","subtractVectors","projection","scaleVector","innerProduct","transposeMatrix","__closure","a0","a1","a2","a3","u0","u1","u2","u3","e0","e1","e2","e3","map","u","Math","sqrt","rotationMatrix","skewMatrix"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AA8RA,SAAAA,oBAASA,CAAqBC,MAAA,CAAqB,OAAAC,eAAA,CAAAC,UAAA,CAAAC,WAAA,CAAAC,YAAA,CAAAC,eAAA,OAAAC,SAAA,CAQjD,KAAM,CAACC,EAAE,CAAEC,EAAE,CAAEC,EAAE,CAAEC,EAAE,CAAC,CAAGV,MAAM,CAE/B,KAAM,CAAAW,EAAE,CAAGJ,EAAE,CACb,KAAM,CAAAK,EAAE,CAAGX,eAAe,CAACO,EAAE,CAAEN,UAAU,CAACS,EAAE,CAAEH,EAAE,CAAC,CAAC,CAClD,KAAM,CAAAK,EAAE,CAAGZ,eAAe,CACxBA,eAAe,CAACQ,EAAE,CAAEP,UAAU,CAACS,EAAE,CAAEF,EAAE,CAAC,CAAC,CACvCP,UAAU,CAACU,EAAE,CAAEH,EAAE,CACnB,CAAC,CACD,KAAM,CAAAK,EAAE,CAAGb,eAAe,CACxBA,eAAe,CACbA,eAAe,CAACS,EAAE,CAAER,UAAU,CAACS,EAAE,CAAED,EAAE,CAAC,CAAC,CACvCR,UAAU,CAACU,EAAE,CAAEF,EAAE,CACnB,CAAC,CACDR,UAAU,CAACW,EAAE,CAAEH,EAAE,CACnB,CAAC,CAED,KAAM,CAACK,EAAE,CAAEC,EAAE,CAAEC,EAAE,CAAEC,EAAE,CAAC,CAAG,CAACP,EAAE,CAAEC,EAAE,CAAEC,EAAE,CAAEC,EAAE,CAAC,CAACK,GAAG,CAAE,SAAAC,CAAC,QAC9C,CAAAjB,WAAW,CAACiB,CAAC,CAAE,CAAC,CAAGC,IAAI,CAACC,IAAI,CAAClB,YAAY,CAACgB,CAAC,CAAEA,CAAC,CAAC,CAAC,CAClD,GAAC,CAED,KAAM,CAAAG,cAA4B,CAAG,CACnC,CAACR,EAAE,CAAC,CAAC,CAAC,CAAEC,EAAE,CAAC,CAAC,CAAC,CAAEC,EAAE,CAAC,CAAC,CAAC,CAAEC,EAAE,CAAC,CAAC,CAAC,CAAC,CAC5B,CAACH,EAAE,CAAC,CAAC,CAAC,CAAEC,EAAE,CAAC,CAAC,CAAC,CAAEC,EAAE,CAAC,CAAC,CAAC,CAAEC,EAAE,CAAC,CAAC,CAAC,CAAC,CAC5B,CAACH,EAAE,CAAC,CAAC,CAAC,CAAEC,EAAE,CAAC,CAAC,CAAC,CAAEC,EAAE,CAAC,CAAC,CAAC,CAAEC,EAAE,CAAC,CAAC,CAAC,CAAC,CAC5B,CAACH,EAAE,CAAC,CAAC,CAAC,CAAEC,EAAE,CAAC,CAAC,CAAC,CAAEC,EAAE,CAAC,CAAC,CAAC,CAAEC,EAAE,CAAC,CAAC,CAAC,CAAC,CAC7B,CAED,KAAM,CAAAM,UAAwB,CAAG,CAC/B,CACEpB,YAAY,CAACW,EAAE,CAAER,EAAE,CAAC,CACpBH,YAAY,CAACW,EAAE,CAAEP,EAAE,CAAC,CACpBJ,YAAY,CAACW,EAAE,CAAEN,EAAE,CAAC,CACpBL,YAAY,CAACW,EAAE,CAAEL,EAAE,CAAC,CACrB,CACD,CAAC,CAAC,CAAEN,YAAY,CAACY,EAAE,CAAER,EAAE,CAAC,CAAEJ,YAAY,CAACY,EAAE,CAAEP,EAAE,CAAC,CAAEL,YAAY,CAACY,EAAE,CAAEN,EAAE,CAAC,CAAC,CACrE,CAAC,CAAC,CAAE,CAAC,CAAEN,YAAY,CAACa,EAAE,CAAER,EAAE,CAAC,CAAEL,YAAY,CAACa,EAAE,CAAEP,EAAE,CAAC,CAAC,CAClD,CAAC,CAAC,CAAE,CAAC,CAAE,CAAC,CAAEN,YAAY,CAACc,EAAE,CAAER,EAAE,CAAC,CAAC,CAChC,CACD,MAAO,CACLa,cAAc,CAAElB,eAAe,CAACkB,cAAc,CAAC,CAC/CC,UAAU,CAAEnB,eAAe,CAACmB,UAAU,CACxC,CAAC,CACH"}',
    version: "3.5.4"
};
var gramSchmidtAlgorithm = function() {
    var _e = [
        new global.Error(),
        -6,
        -27
    ];
    var gramSchmidtAlgorithm = function gramSchmidtAlgorithm(matrix) {
        var _matrix = (0, _slicedToArray2.default)(matrix, 4), a0 = _matrix[0], a1 = _matrix[1], a2 = _matrix[2], a3 = _matrix[3];
        var u0 = a0;
        var u1 = subtractVectors(a1, projection(u0, a1));
        var u2 = subtractVectors(subtractVectors(a2, projection(u0, a2)), projection(u1, a2));
        var u3 = subtractVectors(subtractVectors(subtractVectors(a3, projection(u0, a3)), projection(u1, a3)), projection(u2, a3));
        var _map = [
            u0,
            u1,
            u2,
            u3
        ].map(function(u) {
            return scaleVector(u, 1 / Math.sqrt(innerProduct(u, u)));
        }), _map2 = (0, _slicedToArray2.default)(_map, 4), e0 = _map2[0], e1 = _map2[1], e2 = _map2[2], e3 = _map2[3];
        var rotationMatrix = [
            [
                e0[0],
                e1[0],
                e2[0],
                e3[0]
            ],
            [
                e0[1],
                e1[1],
                e2[1],
                e3[1]
            ],
            [
                e0[2],
                e1[2],
                e2[2],
                e3[2]
            ],
            [
                e0[3],
                e1[3],
                e2[3],
                e3[3]
            ]
        ];
        var skewMatrix = [
            [
                innerProduct(e0, a0),
                innerProduct(e0, a1),
                innerProduct(e0, a2),
                innerProduct(e0, a3)
            ],
            [
                0,
                innerProduct(e1, a1),
                innerProduct(e1, a2),
                innerProduct(e1, a3)
            ],
            [
                0,
                0,
                innerProduct(e2, a2),
                innerProduct(e2, a3)
            ],
            [
                0,
                0,
                0,
                innerProduct(e3, a3)
            ]
        ];
        return {
            rotationMatrix: transposeMatrix(rotationMatrix),
            skewMatrix: transposeMatrix(skewMatrix)
        };
    };
    gramSchmidtAlgorithm.__closure = {
        subtractVectors: subtractVectors,
        projection: projection,
        scaleVector: scaleVector,
        innerProduct: innerProduct,
        transposeMatrix: transposeMatrix
    };
    gramSchmidtAlgorithm.__initData = _worklet_9359996019682_init_data;
    gramSchmidtAlgorithm.__workletHash = 9359996019682;
    gramSchmidtAlgorithm.__stackDetails = _e;
    return gramSchmidtAlgorithm;
}();
var _worklet_1694375123899_init_data = {
    code: "function decomposeMatrix(unknownTypeMatrix){const{maybeFlattenMatrix,norm3d,gramSchmidtAlgorithm}=this.__closure;const matrix=maybeFlattenMatrix(unknownTypeMatrix);if(matrix[15]===0){throw new Error('[Reanimated] Invalid transform matrix.');}matrix.forEach(function(_,i){return matrix[i]/=matrix[15];});const translationMatrix=[[1,0,0,0],[0,1,0,0],[0,0,1,0],[matrix[12],matrix[13],matrix[14],1]];const sx=matrix[15]*norm3d(matrix[0],matrix[4],matrix[8]);const sy=matrix[15]*norm3d(matrix[1],matrix[5],matrix[9]);const sz=matrix[15]*norm3d(matrix[2],matrix[6],matrix[10]);const scaleMatrix=[[sx,0,0,0],[0,sy,0,0],[0,0,sz,0],[0,0,0,1]];const rotationAndSkewMatrix=[[matrix[0]/sx,matrix[1]/sx,matrix[2]/sx,0],[matrix[4]/sy,matrix[5]/sy,matrix[6]/sy,0],[matrix[8]/sz,matrix[9]/sz,matrix[10]/sz,0],[0,0,0,1]];const{rotationMatrix:rotationMatrix,skewMatrix:skewMatrix}=gramSchmidtAlgorithm(rotationAndSkewMatrix);return{translationMatrix:translationMatrix,scaleMatrix:scaleMatrix,rotationMatrix:rotationMatrix,skewMatrix:skewMatrix};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["decomposeMatrix","unknownTypeMatrix","maybeFlattenMatrix","norm3d","gramSchmidtAlgorithm","__closure","matrix","Error","forEach","_","i","translationMatrix","sx","sy","sz","scaleMatrix","rotationAndSkewMatrix","rotationMatrix","skewMatrix"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AAmVO,SAAAA,eAASA,CACdC,iBAAA,CACD,OAAAC,kBAAA,CAAAC,MAAA,CAAAC,oBAAA,OAAAC,SAAA,CAEC,KAAM,CAAAC,MAAM,CAAGJ,kBAAkB,CAACD,iBAAiB,CAAC,CAGpD,GAAIK,MAAM,CAAC,EAAE,CAAC,GAAK,CAAC,CAAE,CACpB,KAAM,IAAI,CAAAC,KAAK,CAAC,wCAAwC,CAAC,CAC3D,CACAD,MAAM,CAACE,OAAO,CAAC,SAACC,CAAC,CAAEC,CAAC,QAAM,CAAAJ,MAAM,CAACI,CAAC,CAAC,EAAIJ,MAAM,CAAC,EAAE,CAAE,GAAC,CAEnD,KAAM,CAAAK,iBAA+B,CAAG,CACtC,CAAC,CAAC,CAAE,CAAC,CAAE,CAAC,CAAE,CAAC,CAAC,CACZ,CAAC,CAAC,CAAE,CAAC,CAAE,CAAC,CAAE,CAAC,CAAC,CACZ,CAAC,CAAC,CAAE,CAAC,CAAE,CAAC,CAAE,CAAC,CAAC,CACZ,CAACL,MAAM,CAAC,EAAE,CAAC,CAAEA,MAAM,CAAC,EAAE,CAAC,CAAEA,MAAM,CAAC,EAAE,CAAC,CAAE,CAAC,CAAC,CACxC,CACD,KAAM,CAAAM,EAAE,CAAGN,MAAM,CAAC,EAAE,CAAC,CAAGH,MAAM,CAACG,MAAM,CAAC,CAAC,CAAC,CAAEA,MAAM,CAAC,CAAC,CAAC,CAAEA,MAAM,CAAC,CAAC,CAAC,CAAC,CAC/D,KAAM,CAAAO,EAAE,CAAGP,MAAM,CAAC,EAAE,CAAC,CAAGH,MAAM,CAACG,MAAM,CAAC,CAAC,CAAC,CAAEA,MAAM,CAAC,CAAC,CAAC,CAAEA,MAAM,CAAC,CAAC,CAAC,CAAC,CAC/D,KAAM,CAAAQ,EAAE,CAAGR,MAAM,CAAC,EAAE,CAAC,CAAGH,MAAM,CAACG,MAAM,CAAC,CAAC,CAAC,CAAEA,MAAM,CAAC,CAAC,CAAC,CAAEA,MAAM,CAAC,EAAE,CAAC,CAAC,CAEhE,KAAM,CAAAS,WAAyB,CAAG,CAChC,CAACH,EAAE,CAAE,CAAC,CAAE,CAAC,CAAE,CAAC,CAAC,CACb,CAAC,CAAC,CAAEC,EAAE,CAAE,CAAC,CAAE,CAAC,CAAC,CACb,CAAC,CAAC,CAAE,CAAC,CAAEC,EAAE,CAAE,CAAC,CAAC,CACb,CAAC,CAAC,CAAE,CAAC,CAAE,CAAC,CAAE,CAAC,CAAC,CACb,CAED,KAAM,CAAAE,qBAAmC,CAAG,CAC1C,CAACV,MAAM,CAAC,CAAC,CAAC,CAAGM,EAAE,CAAEN,MAAM,CAAC,CAAC,CAAC,CAAGM,EAAE,CAAEN,MAAM,CAAC,CAAC,CAAC,CAAGM,EAAE,CAAE,CAAC,CAAC,CACnD,CAACN,MAAM,CAAC,CAAC,CAAC,CAAGO,EAAE,CAAEP,MAAM,CAAC,CAAC,CAAC,CAAGO,EAAE,CAAEP,MAAM,CAAC,CAAC,CAAC,CAAGO,EAAE,CAAE,CAAC,CAAC,CACnD,CAACP,MAAM,CAAC,CAAC,CAAC,CAAGQ,EAAE,CAAER,MAAM,CAAC,CAAC,CAAC,CAAGQ,EAAE,CAAER,MAAM,CAAC,EAAE,CAAC,CAAGQ,EAAE,CAAE,CAAC,CAAC,CACpD,CAAC,CAAC,CAAE,CAAC,CAAE,CAAC,CAAE,CAAC,CAAC,CACb,CAED,KAAM,CAAEG,cAAc,CAAdA,cAAc,CAAEC,UAAA,CAAAA,UAAW,CAAC,CAAGd,oBAAoB,CACzDY,qBACF,CAAC,CAED,MAAO,CACLL,iBAAiB,CAAjBA,iBAAiB,CACjBI,WAAW,CAAXA,WAAW,CACXE,cAAc,CAAdA,cAAc,CACdC,UAAA,CAAAA,UACF,CAAC,CACH"}',
    version: "3.5.4"
};
var decomposeMatrix = exports.decomposeMatrix = function() {
    var _e = [
        new global.Error(),
        -4,
        -27
    ];
    var decomposeMatrix = function decomposeMatrix(unknownTypeMatrix) {
        var matrix = maybeFlattenMatrix(unknownTypeMatrix);
        if (matrix[15] === 0) {
            throw new Error("[Reanimated] Invalid transform matrix.");
        }
        matrix.forEach(function(_, i) {
            return matrix[i] /= matrix[15];
        });
        var translationMatrix = [
            [
                1,
                0,
                0,
                0
            ],
            [
                0,
                1,
                0,
                0
            ],
            [
                0,
                0,
                1,
                0
            ],
            [
                matrix[12],
                matrix[13],
                matrix[14],
                1
            ]
        ];
        var sx = matrix[15] * norm3d(matrix[0], matrix[4], matrix[8]);
        var sy = matrix[15] * norm3d(matrix[1], matrix[5], matrix[9]);
        var sz = matrix[15] * norm3d(matrix[2], matrix[6], matrix[10]);
        var scaleMatrix = [
            [
                sx,
                0,
                0,
                0
            ],
            [
                0,
                sy,
                0,
                0
            ],
            [
                0,
                0,
                sz,
                0
            ],
            [
                0,
                0,
                0,
                1
            ]
        ];
        var rotationAndSkewMatrix = [
            [
                matrix[0] / sx,
                matrix[1] / sx,
                matrix[2] / sx,
                0
            ],
            [
                matrix[4] / sy,
                matrix[5] / sy,
                matrix[6] / sy,
                0
            ],
            [
                matrix[8] / sz,
                matrix[9] / sz,
                matrix[10] / sz,
                0
            ],
            [
                0,
                0,
                0,
                1
            ]
        ];
        var _gramSchmidtAlgorithm = gramSchmidtAlgorithm(rotationAndSkewMatrix), rotationMatrix = _gramSchmidtAlgorithm.rotationMatrix, skewMatrix = _gramSchmidtAlgorithm.skewMatrix;
        return {
            translationMatrix: translationMatrix,
            scaleMatrix: scaleMatrix,
            rotationMatrix: rotationMatrix,
            skewMatrix: skewMatrix
        };
    };
    decomposeMatrix.__closure = {
        maybeFlattenMatrix: maybeFlattenMatrix,
        norm3d: norm3d,
        gramSchmidtAlgorithm: gramSchmidtAlgorithm
    };
    decomposeMatrix.__initData = _worklet_1694375123899_init_data;
    decomposeMatrix.__workletHash = 1694375123899;
    decomposeMatrix.__stackDetails = _e;
    return decomposeMatrix;
}();
var _worklet_11620715816479_init_data = {
    code: "function decomposeMatrixIntoMatricesAndAngles(matrix){const{decomposeMatrix}=this.__closure;const{scaleMatrix:scaleMatrix,rotationMatrix:rotationMatrix,translationMatrix:translationMatrix,skewMatrix:skewMatrix}=decomposeMatrix(matrix);const sinRy=-rotationMatrix[0][2];const ry=Math.asin(sinRy);let rx;let rz;if(sinRy===1||sinRy===-1){rz=0;rx=Math.atan2(sinRy*rotationMatrix[0][1],sinRy*rotationMatrix[0][2]);}else{rz=Math.atan2(rotationMatrix[0][1],rotationMatrix[0][0]);rx=Math.atan2(rotationMatrix[1][2],rotationMatrix[2][2]);}return{scaleMatrix:scaleMatrix,rotationMatrix:rotationMatrix,translationMatrix:translationMatrix,skewMatrix:skewMatrix,rx:rx||0,ry:ry||0,rz:rz||0};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx",
    sourceMap: '{"version":3,"names":["decomposeMatrixIntoMatricesAndAngles","matrix","decomposeMatrix","__closure","scaleMatrix","rotationMatrix","translationMatrix","skewMatrix","sinRy","ry","Math","asin","rx","rz","atan2"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/animation/transformationMatrix/matrixUtils.tsx"],"mappings":"AAmYO,SAAAA,oCAASA,CACdC,MAAA,CACD,OAAAC,eAAA,OAAAC,SAAA,CAEC,KAAM,CAAEC,WAAW,CAAXA,WAAW,CAAEC,cAAc,CAAdA,cAAc,CAAEC,iBAAiB,CAAjBA,iBAAiB,CAAEC,UAAA,CAAAA,UAAW,CAAC,CAClEL,eAAe,CAACD,MAAM,CAAC,CAEzB,KAAM,CAAAO,KAAK,CAAG,CAACH,cAAc,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAEnC,KAAM,CAAAI,EAAE,CAAGC,IAAI,CAACC,IAAI,CAACH,KAAK,CAAC,CAC3B,GAAI,CAAAI,EAAE,CACN,GAAI,CAAAC,EAAE,CACN,GAAIL,KAAK,GAAK,CAAC,EAAIA,KAAK,GAAK,CAAC,CAAC,CAAE,CAC/BK,EAAE,CAAG,CAAC,CACND,EAAE,CAAGF,IAAI,CAACI,KAAK,CAACN,KAAK,CAAGH,cAAc,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAEG,KAAK,CAAGH,cAAc,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAC7E,CAAC,IAAM,CACLQ,EAAE,CAAGH,IAAI,CAACI,KAAK,CAACT,cAAc,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAEA,cAAc,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAC3DO,EAAE,CAAGF,IAAI,CAACI,KAAK,CAACT,cAAc,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAEA,cAAc,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAC7D,CAEA,MAAO,CACLD,WAAW,CAAXA,WAAW,CACXC,cAAc,CAAdA,cAAc,CACdC,iBAAiB,CAAjBA,iBAAiB,CACjBC,UAAU,CAAVA,UAAU,CACVK,EAAE,CAAEA,EAAE,EAAI,CAAC,CACXH,EAAE,CAAEA,EAAE,EAAI,CAAC,CACXI,EAAE,CAAEA,EAAE,EAAI,CACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var decomposeMatrixIntoMatricesAndAngles = exports.decomposeMatrixIntoMatricesAndAngles = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var decomposeMatrixIntoMatricesAndAngles = function decomposeMatrixIntoMatricesAndAngles(matrix) {
        var _decomposeMatrix = decomposeMatrix(matrix), scaleMatrix = _decomposeMatrix.scaleMatrix, rotationMatrix = _decomposeMatrix.rotationMatrix, translationMatrix = _decomposeMatrix.translationMatrix, skewMatrix = _decomposeMatrix.skewMatrix;
        var sinRy = -rotationMatrix[0][2];
        var ry = Math.asin(sinRy);
        var rx;
        var rz;
        if (sinRy === 1 || sinRy === -1) {
            rz = 0;
            rx = Math.atan2(sinRy * rotationMatrix[0][1], sinRy * rotationMatrix[0][2]);
        } else {
            rz = Math.atan2(rotationMatrix[0][1], rotationMatrix[0][0]);
            rx = Math.atan2(rotationMatrix[1][2], rotationMatrix[2][2]);
        }
        return {
            scaleMatrix: scaleMatrix,
            rotationMatrix: rotationMatrix,
            translationMatrix: translationMatrix,
            skewMatrix: skewMatrix,
            rx: rx || 0,
            ry: ry || 0,
            rz: rz || 0
        };
    };
    decomposeMatrixIntoMatricesAndAngles.__closure = {
        decomposeMatrix: decomposeMatrix
    };
    decomposeMatrixIntoMatricesAndAngles.__initData = _worklet_11620715816479_init_data;
    decomposeMatrixIntoMatricesAndAngles.__workletHash = 11620715816479;
    decomposeMatrixIntoMatricesAndAngles.__stackDetails = _e;
    return decomposeMatrixIntoMatricesAndAngles;
}();
